import { render, staticRenderFns } from "./ManageTemplate.vue?vue&type=template&id=2939acac&scoped=true&"
import script from "./ManageTemplate.vue?vue&type=script&lang=js&"
export * from "./ManageTemplate.vue?vue&type=script&lang=js&"
import style0 from "./ManageTemplate.vue?vue&type=style&index=0&id=2939acac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2939acac",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2939acac')) {
      api.createRecord('2939acac', component.options)
    } else {
      api.reload('2939acac', component.options)
    }
    module.hot.accept("./ManageTemplate.vue?vue&type=template&id=2939acac&scoped=true&", function () {
      api.rerender('2939acac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/chile/approvals/components/templates/ManageTemplate.vue"
export default component.exports